import './styles.scss'
import React from 'react'
import { t } from 'i18next'
import { COFFEE_CART } from 'Utils/Constants'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import MetaTagsComponent from 'Components/MetaTagsComponent'

const CoffeeCart = () => {
  const userDetails = getLocalUserDetails()

  return (
    <>
      <MetaTagsComponent title={t('COFFEE_CART_TITLE')} description={t('COFFEE_CART_DESCRIPTION')} keywords={t('COFFEE_CART_KEYWORDS')} url="https://coffeeweb.com/coffeeweb" h1Content={t('COFFEE_CART_H1_CONTENT')} />

      <div className={`coffee-cart-container ${userDetails?.id ? 'logged-in' : 'guest-user'}`}>
        <video controls className="coffee-cart-image" autoPlay loop playsInline>
          <source src={COFFEE_CART.video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </>
  )
}

export default CoffeeCart
